import type { FlipStep } from '@lunary/app-core/flip-variants'

export type RevealTiming = {
  readonly flipAt: number
  readonly glowAt: number
  readonly doneAt: number
  readonly fx: readonly FlipStep[]
}

const EMBERS = ['#ff8a3d', '#ffb35c', '#ffd36e', '#fff2c4']
const GLITTER = ['#ff6fb5', '#ffd36e', '#7dffb2', '#6fd2ff', '#b18cff', '#ffffff']

export const FACE_WAIT_MS = 1500

export const REVEAL_TIMINGS: readonly RevealTiming[] = [
  { flipAt: 100, glowAt: 560, doneAt: 1300, fx: [[520, [{ n: 18, shape: 'spark', speed: 150, life: 1, size: 7, w: 150, h: 260 }]]] },
  {
    flipAt: 120,
    glowAt: 520,
    doneAt: 1300,
    fx: [
      [
        460,
        [
          { n: 110, shape: 'dot', speed: 300, life: 2.6, size: 2.4, drag: 0.93, gravity: -14 },
          { n: 14, shape: 'spark', speed: 180, life: 1, size: 7 },
        ],
      ],
    ],
  },
  { flipAt: 150, glowAt: 600, doneAt: 1450, fx: [[560, [{ n: 26, shape: 'spark', speed: 140, life: 1.2, size: 7, w: 160, h: 280 }]]] },
  { flipAt: 90, glowAt: 380, doneAt: 1000, fx: [[300, [{ n: 46, shape: 'spark', speed: 460, life: 0.8, size: 7 }]]] },
  { flipAt: 100, glowAt: 600, doneAt: 1450, fx: [[580, [{ n: 20, shape: 'dot', speed: 110, life: 1.2, size: 2.4, w: 200, h: 200 }]]] },
  { flipAt: 50, glowAt: 600, doneAt: 1350, fx: [] },
  {
    flipAt: 150,
    glowAt: 780,
    doneAt: 1700,
    fx: [
      [600, [{ n: 50, shape: 'dot', speed: 60, life: 2.4, size: 2.4, gravity: -70, w: 170, h: 200, drag: 0.99 }]],
      [1100, [{ n: 30, shape: 'dot', speed: 50, life: 2, size: 2, gravity: -60, w: 170, h: 260, drag: 0.99 }]],
    ],
  },
  { flipAt: 80, glowAt: 560, doneAt: 1350, fx: [[480, [{ n: 70, shape: 'spark', speed: 260, life: 1.3, size: 6, gravity: 120, colors: GLITTER }]]] },
  {
    flipAt: 120,
    glowAt: 700,
    doneAt: 1700,
    fx: [
      [140, [{ n: 16, shape: 'puff', speed: 70, life: 2, size: 50, w: 120, h: 200 }]],
      [700, [{ n: 10, shape: 'puff', speed: 50, life: 1.8, size: 40, w: 160, h: 260 }]],
    ],
  },
  {
    flipAt: 220,
    glowAt: 540,
    doneAt: 1450,
    fx: [
      [
        500,
        [
          { n: 90, shape: 'dot', speed: 320, life: 2.2, size: 2.6, drag: 0.95, gravity: -60, colors: EMBERS },
          { n: 20, shape: 'spark', speed: 280, life: 1, size: 8, colors: ['#ffd36e', '#fff2c4'] },
        ],
      ],
    ],
  },
]
